module.exports = __webpack_public_path__ + "fonts/avenir/3e419b5b-c789-488d-84cf-a64009cc308e.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/3e419b5b-c789-488d-84cf-a64009cc308e.ttf
// module id = 21
// module chunks = 0